<template>
  <ItemPage
    title="Material"
    size="sm"
    :actions="actions"
  >
    <h2 class="mb-6">
      Status: <span style="color: green"> {{ statusName(textbook.status) }} </span>
    </h2>

    <div class="white">
      <v-row
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          sm="6"
        >
          <div class="font-weight-bold">
            Capa do material
          </div>
        </v-col>
        <v-col
          class="ml-auto"
          cols="auto"
        >
          <v-btn
            color="primary"
            text
            @click="openUrl(textbook.cover_path)"
          >
            <v-icon left>
              mdi-cloud
            </v-icon> abrir capa
          </v-btn>
        </v-col>
      </v-row>
      <v-row
        class="mt-10 mb-10"
        align="center"
        no-gutters
      >
        <v-col
          cols="12"
          sm="6"
        >
          <div class="font-weight-bold">
            Material
          </div>
        </v-col>
        <v-col
          class="ml-auto"
          cols="auto"
        >
          <v-btn
            color="primary"
            text
            @click="openUrl(textbook.path)"
          >
            <v-icon left>
              mdi-cloud
            </v-icon> Abrir Material
          </v-btn>
        </v-col>
      </v-row>
      <v-form
        ref="form"
      >
        <v-row>
          <div class="col-sm-12 col-md-6 d-flex align-center">
            <v-select
              v-model="type"
              class="px-2"
              :items="types"
              item-text="name"
              item-value="id"
              label="Tipo"
            >
              <template
                v-if="type !== null"
                #append
              >
                <v-btn
                  color="primary"
                  text
                  @click="type = null"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-select>
          </div>
          <div class="col-sm-12 col-md-6 d-flex align-center">
            <v-select
              v-model="publishing_year"
              class="px-2"
              :items="years"
              item-text="name"
              item-value="value"
              label="Ano de publicação"
            >
              <template
                v-if="publishing_year !== null"
                #append
              >
                <v-btn
                  color="primary"
                  text
                  @click="publishing_year = null"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-select>
          </div>
          <div class="col-sm-12 col-md-6 d-flex align-center">
            <EducationSystemSelect
              ref="eSSelect"
              :education-system-id-selected="textbook?.education_system_id"
              @setEducationSystem="education_system_id = $event"
            />
          </div>
          <div class="col-sm-12 col-md-6 d-flex align-center">
            <EducationStageSelect
              ref="eStSelect"
              :education-system-id="education_system_id"
              :stage-id-selected="textbook?.education_stage_id"
              @setEducationStage="education_stage_id = $event"
            />
          </div>
          <div
            v-if="enableGrade"
            class="col-sm-12 col-md-6 d-flex align-center"
          >
            <GradeSelect
              ref="gSelect"
              :education-stage-id="education_stage_id"
              :grade-id-selected="textbook?.grade_id"
              @setGrade="grade_id = $event"
            />
          </div>
          <div
            v-if="enableVolume"
            class="col-sm-12 col-md-6 d-flex align-center"
          >
            <GradeVolumeSelect
              ref="gvSelect"
              :grade-id="grade_id"
              :grade-volume-id-selected="textbook?.grade_volume_id"
              @setGradeVolume="grade_volume_id = $event"
            />
          </div>
          <div
            v-if="enableSubject"
            class="col-sm-12 col-md-6 d-flex align-center"
          >
            <GradeSubjectSelect
              ref="gsSelect"
              :grade-id="grade_id"
              :grade-subject-id-selected="textbook?.grade_subject_id"
              @setGradeSubject="grade_subject_id = $event"
              @setGradeSubjectName="name = $event"
            />
          </div>
          <div
            v-if="enableName"
            class="col-sm-12 col-md-6 d-flex align-center"
          >
            <v-text-field
              v-model="name"
              :error-messages="formErrors.name"
              label="Nome do material"
              class="px-2 m-2"
              placeholder="Insira o titulo do material que será enviado"
              hide-details="auto"
              @input="formErrors.name = null"
            />
          </div>
          <div class="col-sm-12 col-md-6 d-flex align-center">
            <v-text-field
              v-model="order"
              class="px-2 m-2"
              label="Ordem"
              type="number"
              hide-details="auto"
              @change="formErrors.order = null"
            />
          </div>
          <div class="col-12">
            <hr>
          </div>
          <div class="col-sm-12 col-md-6 d-flex align-center justify-space-between">
            Material do professor
            <v-switch
              v-model="is_teacher_material"
              class="pa-2"
              :label="is_teacher_material ? 'Sim' : 'Não'"
            />
          </div>
        </v-row>
      </v-form>
    </div>
  </ItemPage>
</template>

<script>
import utils from '@/api/utils.js'
import EducationSystemSelect from '@/components/contents/EducationSystemSelect.vue'
import EducationStageSelect from '@/components/contents/EducationStageSelect.vue'
import GradeSelect from '@/components/contents/GradeSelect.vue'
import GradeVolumeSelect from '@/components/contents/GradeVolumeSelect.vue'
import GradeSubjectSelect from '@/components/contents/GradeSubjectSelect.vue'
import handlesServerValidation from '@/mixins/handles-server-validation.js'
import ItemPage from '@/components/pages/ItemPage.vue'
import { types as materialTypes, listTypes } from '@/enums/materialTypes'
import { listTypes as listVolumeTypes } from '@/enums/volumeTypes'
import { getTextForDisplay as statusName } from '@/enums/materialStatus'

export default {
  components: {
    ItemPage,
    EducationSystemSelect,
    EducationStageSelect,
    GradeSelect,
    GradeVolumeSelect,
    GradeSubjectSelect
  },

  mixins: [
    handlesServerValidation
  ],
  data () {
    return {
      textbook: {},
      type: null,
      publishing_year: null,
      education_system_id: null,
      education_stage_id: null,
      grade_id: null,
      grade_volume_id: null,
      grade_subject_id: null,
      is_teacher_material: false,
      name: '',
      order: null,
      subjectTextBooksUpdate: false,
      subjectTextBooksDelete: false,
      rulesName: [
        value => !!value || 'Preenchimento obrigatório.',
        value => (value && value.length >= 3) || 'Min 3 caracteres'
      ],
      years: [
        new Date().getFullYear() + 1,
        new Date().getFullYear(),
        new Date().getFullYear() - 1,
        new Date().getFullYear() - 2,
        new Date().getFullYear() - 3
      ]
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Atualizar',
          action: this.updateTextBook,
          icon: 'mdi-floppy',
          disabled: this.subjectTextBooksUpdate
        },
        {
          label: 'Deletar',
          action: this.deleteTextBook,
          icon: 'mdi-delete',
          disabled: !this.subjectTextBooksDelete
        }
      ]
    },
    id () {
      return this.$route.params.id
    },
    enableName () {
      return this.type !== materialTypes.Teoric
    },
    enableGrade () {
      return ![materialTypes.Project, materialTypes.Supplementary].includes(this.type)
    },
    enableVolume () {
      return ![materialTypes.Project, materialTypes.Supplementary, materialTypes.Additional].includes(this.type)
    },
    enableSubject () {
      return [materialTypes.Teoric].includes(this.type)
    }
  },
  watch: {
    'textbook.type' (newVal) {
      this.hideVolumeField = false
      this.hideSubjectField = false
      this.hideGradeLevelField = false
      if ([materialTypes.Additional].includes(newVal)) {
        this.textbook.subject_id = null
        this.textbook.volume_id = null
        // this.textbook.name = ''
        this.hideVolumeField = true
        this.hideSubjectField = true
      }
      if ([materialTypes.Activity].includes(newVal)) {
        this.textbook.subject_id = null
        // this.textbook.name = ''
        this.hideSubjectField = true
      }
      if ([materialTypes.Project, materialTypes.Supplementary].includes(newVal)) {
        this.textbook.grade_level_id = null
        this.textbook.subject_id = null
        this.textbook.volume_id = null
        // this.textbook.name = ''
        this.hideVolumeField = true
        this.hideSubjectField = true
        this.hideGradeLevelField = true
      }
    }
  },
  created () {
    this.subjectTextBooksUpdate = !utils.checkPermissions('subject-textbooks.update-any')
    this.subjectTextBooksDelete = utils.checkPermissions('subject-textbooks.delete')
    this.fetchAll()
  },
  methods: {
    listTypes,
    listVolumeTypes,
    async fetchAll () {
      this.types = listTypes()
      await this.getTextBook()
    },

    async getTextBook () {
      try {
        const response = await this.$api.getTextBook(this.id)
        this.textbook = response
        console.log(this.textbook)
        this.type = this.textbook.type
        this.publishing_year = this.textbook.publishing_year
        this.is_teacher_material = this.textbook.is_teacher_material
        this.name = this.textbook.name
        this.order = this.textbook.order
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível obter o material, tente novamente mais tarde.', color: 'red' })
      }
    },
    openUrl (url) {
      window.open(url)
    },
    validate () {
      return this.$refs.form.validate()
    },
    uploadMaterial () {
      this.waitingUpload = false
    },
    async deleteTextBook () {
      this.$dialog.confirm('Apagar material?')
        .text('Essa ação não pode ser desfeita')
        .label('Apagar')
        .onConfirm(async () => {
          try {
            await this.$api.deleteTextBook(this.id)
            this.$store.dispatch('setSnackBar', { text: 'Material excluido com sucesso.' })
            this.$router.back()
          } catch {
            this.$store.dispatch('setSnackBar', { text: 'Não foi possível Excluir, tente novamente mais tarde.', color: 'red' })
          }
        })
        .show()
    },
    async updateTextBook () {
      const textbook = {
        type: this.type,
        publishing_year: this.publishing_year,
        education_system_id: this.education_system_id,
        education_stage_id: this.education_stage_id,
        grade_id: this.grade_id,
        grade_volume_id: this.grade_volume_id,
        grade_subject_id: this.grade_subject_id,
        is_teacher_material: this.is_teacher_material,
        name: this.name,
        order: this.order
      }
      try {
        await this.$api.updateTextBook(this.id, textbook)
        this.$store.dispatch('setSnackBar', { text: 'Material atualizado com sucesso.' })
        this.fetchAll()
      } catch (e) {
        this.getErrors(e)
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível atualizar, tente novamente mais tarde.', color: 'red' })
      }
    },
    statusName
  }
}
</script>
